import { useId } from "react";
import { Angle, Maximize2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useScheduleStore } from "../../../stores/schedule-store";
import { dispatchScheduleEvent } from "../../../lib/schedule-history/dispatch";
import { PlacementNumberField } from "../developer-section/PlacementNumberField";
import { MetadataElementLayout } from "../developer-section/MetadataElementLayout";

export function HandleTransformControls() {
  const { t } = useTranslation();
  const id = useId();
  const preset = useScheduleStore(state => state.preset);
  const canvasMetadata = useScheduleStore(state => state.canvasMetadata);
  const positionOverride = useScheduleStore(state => state.artistHandlePosition);
  const rotation = useScheduleStore(state => state.artistHandleRotation);
  const scale = useScheduleStore(state => state.artistHandleScale);
  const metadata = canvasMetadata ?? preset.metadata;
  const artistElement = metadata?.globals.find(
    element => element.bind === "profile.artist_handle",
  );
  const position = positionOverride ?? artistElement?.position ?? [0, 0];
  const transformFields = [
    { key: "x", label: t("art.x"), value: position[0] ?? 0 },
    { key: "y", label: t("art.y"), value: position[1] ?? 0 },
    { key: "size", label: t("art.size"), value: scale * 100 },
    { key: "rotation", label: t("art.rotation"), value: rotation ?? artistElement?.rotation ?? 0 },
  ] as const;

  return (
    <MetadataElementLayout fields={transformFields.map(({ key, label, value }) => ({
      key,
      content: <PlacementNumberField id={`${id}-${key}`} value={Math.round(value * 100) / 100}
        label={key === "size" ? <Maximize2 className="size-3.5" /> : key === "rotation" ? <Angle className="size-3.5" /> : key.toUpperCase()}
        title={label} size={key === "size"} rotation={key === "rotation"} precision={2} disabled={!artistElement}
        onChange={value => {
          if (key === "rotation") {
            dispatchScheduleEvent({ type: "handle/setRotation", rotation: value }, "handle:rotation");
            return;
          }
          if (key === "size") {
            dispatchScheduleEvent({ type: "handle/setScale", scale: value / 100 }, "handle:size");
            return;
          }
          const state = useScheduleStore.getState();
          const currentPosition = state.artistHandlePosition ?? artistElement?.position ?? [0, 0];
          const coordinate = key === "x" ? 0 : 1;
          const nextPosition = [...currentPosition];
          nextPosition[coordinate] = value;
          dispatchScheduleEvent({ type: "handle/setPosition", position: nextPosition }, `handle:${key}`);
        }} />,
    }))} />
  );
}
